var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-840 -207)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    transform: "translate(840 207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1165.133 859.822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2125.576-486.822a45.56,45.56,0,0,1-44.96-38.752,45.357,45.357,0,0,1,38.142-51.666c14.739-2.248,27.7,2.054,38.6,12.311,1.418,1.334,1.551,2.61.492,3.729-1.012,1.069-2.4,1.005-3.77-.306A40.759,40.759,0,0,0,2127.01-573c-18.259-.885-35.2,11.363-40.445,29.217a40.666,40.666,0,0,0,27.19,50.372c14.625,4.35,27.792,1.2,39.324-8.786.444-.385.86-.8,1.3-1.2a2.276,2.276,0,0,1,3.47-.01c1.159,1.161.842,2.4-.214,3.447a44.371,44.371,0,0,1-9.478,7.2A44.963,44.963,0,0,1,2125.576-486.822Z",
    transform: "translate(0 0)",
    fill: "#053e74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2246.117-481.747c-8.266,0-15.961.006-23.657,0-1.971,0-2.894-.785-2.885-2.364s.936-2.329,2.916-2.332q11.061-.014,22.123,0h1.572c-2.4-2.344-4.466-4.352-6.524-6.364-.466-.456-.939-.907-1.376-1.39a2.179,2.179,0,0,1,.027-3.3,2.146,2.146,0,0,1,3.3,0q5.919,5.845,11.765,11.764a2.153,2.153,0,0,1,0,3.3q-5.846,5.919-11.763,11.767a2.149,2.149,0,0,1-3.3-.013,2.2,2.2,0,0,1,.115-3.443C2240.853-476.568,2243.311-478.974,2246.117-481.747Z",
    transform: "translate(-84.521 -48.21)",
    fill: "#053e74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2192.088-468.318a2.241,2.241,0,0,1,2.31,2.351,2.154,2.154,0,0,1-2.257,2.372A2.25,2.25,0,0,1,2189.72-466,2.27,2.27,0,0,1,2192.088-468.318Z",
    transform: "translate(-66.423 -66.374)",
    fill: "#053e74"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.73464d8bfa67eaa217545759ff64101e.svg";
export { ForwardRef as ReactComponent };